import './src/styles/bootstrap.min.css';
import 'react-tabs/style/react-tabs.css';

import './src/styles/global.scss';

import 'firebase/auth';

import React from 'react';
import AuthProvider from './src/context/auth';

export const wrapRootElement = ({ element }) => {
  document.getElementById('___gatsby').style.display = 'none';

  setTimeout(function () {
    document.getElementById('___loader').style.display = 'none';
    document.getElementById('___gatsby').style.display = 'block';
  }, 1500);
  return <AuthProvider>{element}</AuthProvider>;
};
